export default __webpack_public_path__ + "f1e08b9.png";